export const formSectionsMoreThanFiveStyles = {
    navWrap: {
        display: "flex",
        alignItems: "center",
        gap: 1,
        mb: 2,
    },
    scrollBox: {
        position: "relative",
        flex: 1,
        overflowX: "auto",
        overflowY: "hidden",
        pb: 1,

        // hide scrollbar but keep scrolling
        scrollbarWidth: "none" as const,
        "&::-webkit-scrollbar": { display: "none" },

        // subtle fade edges to hint that it scrolls
        "&:before, &:after": {
            content: '""',
            position: "sticky",
            top: 0,
            width: 24,
            height: "100%",
            zIndex: 1,
            pointerEvents: "none",
        },
        "&:before": {
            left: 0,
            background:
                "linear-gradient(to right, rgba(255,255,255,1), rgba(255,255,255,0))",
        },
        "&:after": {
            right: 0,
            background:
                "linear-gradient(to left, rgba(255,255,255,1), rgba(255,255,255,0))",
        },
    },
    stepper: {
        minWidth: "max-content",
    },
    progressWrap: { mb: 1.5 },
} as const;
